import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollService {
  private _bodyElement: HTMLElement | null = document.body;

  activateScroll(): void {
    if (this._bodyElement) {
      Object.assign(this._bodyElement.style, { 'overflow-y': 'auto', position: '' });
    }
  }

  deactivateScroll(): void {
    if (this._bodyElement) {
      Object.assign(this._bodyElement.style, { 'overflow-y': 'hidden', position: 'fixed' });
    }
  }
}
